const THE_MOVIE_DB_BASE_URL = 'https://image.tmdb.org/t/p/';

export default THE_MOVIE_DB_BASE_URL;
